import { abandonmentTriggerCallback } from '../../../helpers';
/*
 * Init Abandonment listener
 */
export function triggerAbandonmentExperience() {
	document.querySelector('body').addEventListener('mouseleave', abandonmentTriggerCallback);
}
